<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>常見問答</h1>
                        <span>對Trinka有疑問？請參見以下常見問答。</span>
                        <!-- <a href="https://demo.trinka.ai/" target="_blank">Try it Now</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="verticalTabSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="questionSections">
                    <ul class="nav nav-tabs">
                        <li (click)="gotoTop()"><a class="active" href="#TrinkaTabs" data-toggle="tab">Trinka</a></li>
                        <li (click)="gotoTop()"><a href="#AccountTabs" data-toggle="tab">用戶帳號</a></li>
                        <li (click)="gotoTop()"><a href="#AccountPaymentsTabs" data-toggle="tab">付款</a></li>
                        <li (click)="gotoTop()"><a href="#PlansTabs" data-toggle="tab">價格方案</a></li>
                        <li (click)="gotoTop()"><a href="#GeneralTabs" data-toggle="tab">一般</a></li>
                        <li (click)="gotoTop()"><a href="#SecurityTab" data-toggle="tab">資料安全</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-8">
                <div class="answersSections">
                    <div class="tab-content">
                        <div class="tab-pane active" id="TrinkaTabs">
                            <div class="accordion" id="TrinkaTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionOneContent"> 什麼是Trinka?</a>
                                    </div>

                                    <div id="TrinkaQuestionOneContent" class="collapse show"
                                        aria-labelledby="TrinkaQuestionOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka是人工智慧寫作助手，可以檢查您的文本是否存在文法、拼寫、風格和一致性錯誤，並提供糾正和可操作的回饋。它的功能遠不止於校正，它為您提供最好的語調和風格增強建議。此外Trinka還會檢查您的寫作是否有偏見和敏感語言，為您提供簡潔寫作的技巧，減少冗餘的表達。Trinka的學術寫作功能可以編寫特定學科的短語和術語，並使用對沖詞、縮略語和正式英語。此外，它還檢查您的手稿是否已經做好發表準備。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTwoContent">Trinka與其他用於檢查寫作的線上工具有何不同？</a>
                                    </div>

                                    <div id="TrinkaQuestionTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>雖然通用英語有幾個文法檢查工具，但很少有人關注學術英語寫作、術語、科學慣例和與出版準備相關的問題。Trinka專為需要英語寫作説明的學術作者量身打造。在我們最近的比較中，我們發現Trinka是最適合學術寫作的助手，因為它準確度最高，而且還涵蓋了廣泛的寫作問題。 <a href="/tw/trinka-vs-grammarly-vs-language-tool" target="_blank" >按一下此</a> 處閱讀白皮書。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionThreeContent">Trinka如何檢查我的寫作？</a>
                                    </div>

                                    <div id="TrinkaQuestionThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka接受了來自不同學科領域的數百萬份手稿的訓練，並使用了自然語言處理（NLP）演算法和文法規則的組合，這些演算法和規則會定期更新並經過嚴格的測試。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFourContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFourContent">Trinka文法檢查的準確性有多高？</a>
                                    </div>

                                    <div id="TrinkaQuestionFourContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFour" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka是專為學術內容而設計的，因此在學術/技術內容方面的表現最好。對相關資料集的評估表明，Trinka通常可以捕獲文檔中80%的錯誤並且達到90%以上的準確率。這是我們要保持的最重要的平衡，對於在學術/技術內容上取得最佳檢查結果至關重要。當然結果可能對不同測試者略有差別，但您的每一個回饋都會使Trinka變得更好。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFiveContent">Trinka這個文法檢查工具可以免費使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，Trinka的基本計畫是完全免費使用的。但是它確實存在一些使用限制，您可以查看我們的<a href="/tw/pricing" target="_blank">價格頁面</a>瞭解更多詳情。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSixContent">Trinka如何幫助技術寫作？</a>
                                    </div>

                                    <div id="TrinkaQuestionSixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka是一種基於人工智慧的文法檢查器工具，可以檢查3000多項複雜的文法錯誤、語調和風格增強、根據 APA和AMA風格指南對文字進行格式化，並適用於所有學科領域。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSevenContent">Trinka可以取代寫作校對嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionSevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>這取決於原作的寫作品質。如果您的母語不是英語並且犯了許多與英語邏輯結構有關的複雜錯誤，那麼聘請專業校對人員將是非常有益的。Trinka可以糾正數以千計的文法錯誤和複雜的寫作問題，然而人工智慧總有它的局限性。如果原作結構混亂、邏輯不通，Trinka就無法解讀您的意圖。相比之下，如果您對英語有足夠的瞭解，可以自信地寫出邏輯正確的結構，那麼Trinka 就可以處理剩餘的問題，包括語氣、單詞選擇、文法結構、拼寫等等。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionEightContent">Trinka用於寫論文安全嗎？我能用它來檢查我論文中的文法嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，Trinka適用於所有形式的學術/技術寫作，您絕對可以將其用於論文、研究論文、報告、論文等。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionNineContent">Can Trinka check a PDF for grammar and or spelling issues? </a>
                                    </div>
    
                                    <div id="TrinkaQuestionNineContent" class="collapse" aria-labelledby="TrinkaQuestionNine"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Currently, Trinka supports MS Word files (doc/docx). We will add support for pdf and LaTeX files soon. </p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTenContent">Trinka能檢查PDF文件的文法和拼寫問題嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionTenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>目前，Trinka僅支持微軟Word文件(doc/docx格式)， 我們將很快添加對pdf和LaTeX文件的支持。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestioneleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelevenContent">如果正確的單詞被標記為拼寫錯誤，您應該怎麼處理？</a>
                                    </div>

                                    <div id="TrinkaQuestionelevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestioneleven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka的人工智慧模型從數百萬已發佈的內容中學習。然而它偶爾也會遇到新詞。如果它在您確定拼寫正確時突出顯示拼寫錯誤的單詞，只需將其添加到您的個人Trinka詞典中（查看建議卡上的“添加到詞典”按鈕）。一旦您將單詞添加到字典中，Trinka就不會將其突出顯示為錯誤。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwelveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwelveContent">使用Trinka，我的文字會被標記為抄襲嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwelveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwelve" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka説明改善您的寫作，消除語言問題。抄襲是指您使用已發表的文本而沒有正確引用來源。雖然使用Trinka不會引入抄襲內容，但我們建議使用我們的抄襲檢查來檢查您的文件，以確保您沒意外地使用抄襲內容。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelThirteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelThirteenContent">Trinka能否將文章以APA格式排版？</a>
                                    </div>

                                    <div id="TrinkaQuestionelThirteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelThirteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，您可以使用Trinka內置的APA風格指南選項來應用所有APA語言以及寫作偏好。請注意，當前Trinka版本不會應用APA的某些設定，例如頁邊距、編號、標題樣式等。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFourteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFourteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFourteenContent">Trinka是否支援英語以外的語言？</a>
                                    </div>

                                    <div id="TrinkaQuestionelFourteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFourteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>不支援，Trinka只處理英語內容。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFiveteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFiveteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFiveteenContent">我可以在多個設備上使用Trinka 嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelFiveteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFiveteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的！ 您可以在電腦（PC、Mac、Chromebook）、平板電腦（iPad、Android、Windows）、移動設備（iOS、Android、其他作業系統）上使用 Trinka 網站。您可以在任何支援現代網路瀏覽器的設備上使用 Trinka。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSixteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSixteenContent">我可以使用 Trinka的應用程式介面（API）嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelSixteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSixteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的。Trinka強大的應用程式介面（API）可讓您將其集成到任何應用程式中。簡單易用的API提供了高可靠性和可擴展性。請訪問我們 <a href="/tw/enterprise" target="_blank">的企業</a>部分瞭解更多詳情。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSeventeenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSeventeenContent">我可以同時從多個設備登錄我的 Trinka帳戶嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelSeventeenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSeventeen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的可以。但是請注意您不能從多個位置處理同一個文件，您一次只能從一個設備/瀏覽器在Trinka中編輯文件。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">What is the maximum word count Trinka can check?</a>
                                    </div>
    
                                    <div id="TrinkaQuestionelEighteenContent" class="collapse" aria-labelledby="TrinkaQuestionelEighteen"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka can check for language and grammar for up to 150 words on our demo tool, and this limit gets exceeded once you register for free.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelNineteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelNineteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelNineteenContent">Trinka的Word外掛程式與哪些版本的微軟 Word相容？</a>
                                    </div>

                                    <div id="TrinkaQuestionelNineteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelNineteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka Word外掛程式與Windows系統上的微軟Word 2010 及更高版本相容，<a href="/tw/wordplugin" target="_blank">點擊這</a>裡查看更多詳情。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">Trinka能在google瀏覽器Chrome上使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelEighteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelEighteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，您可以從<a href="/tw/browser-plugin" target="_blank">這裡</a>安裝Trinka的Chrome瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwoenty">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwoentyContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwoentyContent">Trinka能在火狐瀏覽器（Firefox）上能用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwoentyContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwoenty" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，您可以從<a href="/tw/browser-plugin" target="_blank">這裡</a>安裝Trinka的Firefox瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyOneContent">Trinka能在Edge上使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyOneContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，您可以從<a href="/tw/browser-plugin" target="_blank">這裡</a>安裝Trinka的Edge瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyTwoContent">為什麼Trinka的瀏覽器外掛程式在某些網站上不起作用？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>允許創建內容的網站可能使用不同的架構和設計，有時網站會干擾Trinka擴展程式讀取您文章的方式。如果遇到Trinka無法正常工作的網站，請與我們分享您的回饋，我們將找到解決方案。您可以隨時發送電子郵件至<a href="mailto:support@trinka.ai">support@trinka.ai</a>尋求幫助。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyThreeContent">Trinka能在Facebook上使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>當然可以，只需在您的瀏覽器上安裝Trinka瀏覽器外掛程式就可以了。您可以在<a href="/tw/browser-plugin" target="_blank">這裡</a>找到瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyFoureContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyFoureContent">Trinka能在LinkedIn上使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyFoureContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyFoure" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>當然可以，只需在您的瀏覽器上安裝Trinka瀏覽器外掛程式就可以了。您可以在<a href="/tw/browser-plugin" target="_blank">這裡</a>找到瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyFiveContent">Trinka能在Reddit上使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>當然可以，只需在您的瀏覽器上安裝Trinka瀏覽器外掛程式就可以了。您可以在<a href="/tw/browser-plugin" target="_blank">這裡</a>找到瀏覽器外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySixContent">Trinka支持LaTeX檔案格式嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>目前Trinka不支持LaTeX文件，我們將很快添加對這種格式的支持。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySevenContent">Trinka在我的句子中做了兩處或兩處以上的更正，但為什麼應用了一處更正，另一處就消失？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>有一種可能是，應用完第一次更正後第二次更正或其他更正就不再需要了。請注意，用戶接受其中一個建議並對句子進行更改後，Trinka會重新檢查修改後的句子是否存在錯誤。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">寫作顧問有什麼用處，它與增強功能有何不同？</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>寫作顧問專為那些希望在文本中使用學術語調的作家而設計，這些特點是學術英語寫作和科學慣例所獨有的。 寫作顧問提供有關模糊限制語或加強詞、弱修飾語、可轉化為主動語態的被動語態句子以及句子的整體品質的回饋。增強功能僅涵蓋文法上合理但有進一步改進和完善空間的寫作方面，例如通過使用簡潔的詞彙來減少字數，消除偏見或敏感的語言，或使用更簡單的詞代替較長較複雜的詞。</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyEightContent">Trinka可以離線使用嗎？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>不能離線使用，Trinka需要使用互聯網連接來檢查您的文本是否存在錯誤。但是您可以嘗試我們 <a href="https://www.trinka.ai/tw/features/auto-file-edit">的自動文件編輯功</a>能，該功能允許您上傳微軟Word文件並下載跟蹤更改的版本以供離線查看。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyNineContent">使用Trinka可以檢查哪些類型的文件？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyNineContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyNine" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>目前我們支持微軟Word文件(doc/docx格式)、txt文件和rtf文件，我們將很快添加對pdf和LaTeX文件的支持。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionel30">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionel30Content" aria-expanded="true"
                                            aria-controls="TrinkaQuestionel30Content">Trinka的抄襲檢查比其他工具好在哪裡？</a>
                                    </div>

                                    <div id="TrinkaQuestionel30Content" class="collapse"
                                        aria-labelledby="TrinkaQuestionel30" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>與其他工具不同的是，Trinka可以讓您選擇適合您個人需求的抄襲檢查 - 無論您需要檢查網路內容還是網路內容+付費出版物。透過與iThenicate的合作，Trinka提供了卓越的抄襲檢測技術，得到了全球大型學術出版商的信任。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountPaymentsTabs">
                            <div class="accordion" id="APTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="APQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionOneContent" aria-expanded="true"
                                            aria-controls="APQuestionOneContent">為什麼我的信用卡被拒絕了？</a>
                                    </div>

                                    <div id="APQuestionOneContent" class="collapse show" aria-labelledby="APQuestionOne"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>這個問題可能有下面幾個原因：</p>
                                            <ol>
                                                <li>您的信用卡不支援國際交易；</li>
                                                <li>您輸入了錯誤的詳細資訊；</li>
                                                <li>您的信用額度已用完。</li>
                                            </ol>
                                            <p>如果問題仍然存在，請聯繫您的銀行。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="APQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionTwoContent" aria-expanded="true"
                                            aria-controls="APQuestionTwoContent">請問你們接受哪些付款方式？</a>
                                    </div>

                                    <div id="APQuestionTwoContent" class="collapse" aria-labelledby="APQuestionTwo"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinka目前接受信用卡付款，所有支援國際交易的信用卡都應該可以使用。如果您在付款方式方面遇到問題，可以發送電子郵件至 <a href="mailto:support@trinka.ai">support@trinka.ai</a>。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionThreeContent">請問在哪裡可以輸入我的折扣/優惠券代碼？</a>
                                    </div>

                                    <div id="GenernalQuestionThreeContent" class="collapse"
                                        aria-labelledby="GenernalQuestionThree" data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>目前您將可以通過收到的用於打折購買的獨特付款連結進行支付。我們正在更新系統，很快您就可以在付款時直接輸入您的折扣代碼。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountTabs">
                            <div class="accordion" id="AccountQuestions">
                                <div class="card">
                                    <div class="card-header" id="AccountQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionOneContent" aria-expanded="true"
                                            aria-controls="AccountQuestionOneContent">Trinka瀏覽器外掛程式沒有檢測到我的高級帳戶。</a>
                                    </div>

                                    <div id="AccountQuestionOneContent" class="collapse show"
                                        aria-labelledby="AccountQuestionOne" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>安裝瀏覽器外掛程式後，您需要通過它登錄您的Trinka帳戶。如果您在登錄時遇到困難，請發送電子郵件至<a href="mailto:support@trinka.ai">support@trinka.ai</a>。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionTwoContent" aria-expanded="true"
                                            aria-controls="AccountQuestionTwoContent">我該如何申請退款？</a>
                                    </div>

                                    <div id="AccountQuestionTwoContent" class="collapse"
                                        aria-labelledby="AccountQuestionTwo" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>根據我們的政策，我們對購買的訂閱不提供退款服務。您可以通過<a href="mailto:support@trinka.ai">support@trinka.ai</a>發送郵件讓我們取消已有訂閱的自動續訂。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="AccountQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionThreeContent" aria-expanded="true"
                                            aria-controls="AccountQuestionThreeContent">I am unable to receive
                                            verification email</a>
                                    </div>

                                    <div id="AccountQuestionThreeContent" class="collapse"
                                        aria-labelledby="AccountQuestionThree" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Please check the spam folder for the verification mail. If you still are
                                                unable to find the verification mail, then please contact our support on
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> and we will be
                                                glad to assist you.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionFoureContent" aria-expanded="true"
                                            aria-controls="AccountQuestionFoureContent">如何刪除我的帳戶？</a>
                                    </div>

                                    <div id="AccountQuestionFoureContent" class="collapse"
                                        aria-labelledby="AccountQuestionFoure" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>請發送電子郵件至<a href="mailto:support@trinka.ai">support@trinka.ai</a>。</p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="tab-pane" id="PlansTabs">
                            <div class="accordion" id="PlansTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionOneContent" aria-expanded="true"
                                            aria-controls="PlanQuestionOneContent">訂閱是否自動更新？</a>
                                    </div>

                                    <div id="PlanQuestionOneContent" class="collapse show"
                                        aria-labelledby="PlanQuestionOne" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p class="mb-2">是的，訂閱會自動更新。如果你想取消自動續訂，請按照以下步驟進行。</p>
                                            <ul>
                                                <li><a href="https://cloud.trinka.ai/signin?_rg=GB" class="hyperLink" target="_blank">登錄</a> 到您的Trinka帳戶。</li>
                                                <li>點擊您儀錶板右上角的 "帳戶設置 "按鈕。</li>
                                                <li>點擊訂閱中給出的 "取消訂閱 "鏈接。</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="PlanQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionTwoContent" aria-expanded="true"
                                            aria-controls="PlanQuestionTwoContent">Can I get a student discount?</a>
                                    </div>

                                    <div id="PlanQuestionTwoContent" class="collapse" aria-labelledby="PlanQuestionTwo"
                                        data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Yes, student discounts are available. Write to us at <a
                                                    href="mailto:sales@trinka.ai">sales@trinka.ai</a> to know more and
                                                get your student discount.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="PlanQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionThreeContent" aria-expanded="true"
                                            aria-controls="PlanQuestionThreeContent">請問我可以升級我的訂閱嗎？</a>
                                    </div>

                                    <div id="PlanQuestionThreeContent" class="collapse"
                                        aria-labelledby="PlanQuestionThree" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>請發送電子郵件至<a href="mailto:support@trinka.ai">support@trinka.ai</a>，您很快就可以在您的帳戶設置中進行這個操作。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionFourContent" aria-expanded="true"
                                            aria-controls="PlanQuestionFourContent">請問批量或者團購有折扣嗎？</a>
                                    </div>

                                    <div id="PlanQuestionFourContent" class="collapse"
                                        aria-labelledby="PlanQuestionFour" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>有的，團隊方案根據團隊的規模提供折扣。您可以發送電子郵件至<a href="mailto:sales@trinka.ai">sales@trinka.ai</a>，為您的團隊訂製報價。</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane" id="GeneralTabs">
                            <div class="accordion" id="GeneralTabsQuestion">
                                <!-- <div class="card">
                                    <div class="card-header" id="GeneralQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionOneContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionOneContent">How to enable grammar checker in
                                            MS Word?</a>
                                    </div>

                                    <div id="GeneralQuestionOneContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionOne" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Once you have installed Trinka MS Word Add-in, open any document in MS Word, look out for Trinka in the toolbar, and click
                                                to open it. Log in using your Trinka credentials if prompted. Once you
                                                are logged in, you should see the Trinka toolbar, and it should also
                                                start displaying the suggestions.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionTwoContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionTwoContent">我需要下載文法檢查軟體嗎？</a>
                                    </div>

                                    <div id="GeneralQuestionTwoContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionTwo" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>您無需下載任何軟體即可使用Trinka，只需從Web瀏覽器登錄並開始使用Trinka。但是如果您想在微軟Word中使用Trinka進行文法檢查，則需要安裝我們即將推出的微軟Word外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionThreeContent">請問什麼是上下文拼寫檢查工具？</a>
                                    </div>

                                    <div id="GeneralQuestionThreeContent" class="collapse"
                                        aria-labelledby="GeneralQuestionThree" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>上下文拼寫檢查工具可識別在上下文中錯誤使用的單詞，例如預期的單詞“site”可能會變成“sight”，普通的拼寫檢查工具無法識別這樣的錯誤。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFoureContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFoureContent">請問技術寫作與一般寫作有何不同？</a>
                                    </div>

                                    <div id="GenernalQuestionFoureContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFoure" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>一般寫作和技術寫作都遵循相同的文法、拼寫和標點規則。但是技術寫作具有專業的語調和風格，包括報告事實、細節、統計資料等。同時技術寫作不包含觀點，而一般寫作則包含。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFiveContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFiveContent">請問技術寫作與學術寫作有何不同？</a>
                                    </div>

                                    <div id="GenernalQuestionFiveContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFive" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>技術寫作側重於提供有關服務或產品的詳細而清晰的資訊，而學術寫作側重於證明理論或觀點，並強調一個特定主題。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSixContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSixContent">Trinka是否與蘋果的Mac系統相容？</a>
                                    </div>

                                    <div id="GenernalQuestionSixContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSix" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>是的，您可以在所有作業系統上使用Trinka Cloud（Trinka網站），我們將很快發佈適用於Windows和Mac電腦的Trinka微軟Word外掛程式。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSevenContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSevenContent">請問你們有營銷計畫嗎？</a>
                                    </div>

                                    <div id="GenernalQuestionSevenContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSeven" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>有，Trinka的網路行銷計畫允許您在將客戶推薦到我們的網站時賺取收益，您可以很容易加入該計畫且完全免費，您可以在<a href="/tw/affiliates" target="_blank">此處</a>找到更多詳細資訊。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">What does Writing Adviser do
                                            and how is it different from Enhancements?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Writing Adviser is designed for writers who wish to employ an academic
                                                tone in their texts. These features are unique to academic English
                                                writing and scientific convention. It provides feedback on hedge or
                                                booster words, weak modifiers, passive voice sentences that can be
                                                changed to the active voice, and the overall quality of sentences.
                                                Enhancements cover only those aspects of writing which are grammatically
                                                sound but have scope for further improvement and polishing, e.g.,
                                                reducing the word count employing concise words, neutralizing biased or
                                                sensitive language, or using simpler words in place of longer, complex
                                                ones.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionNineContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionNineContent">請問我可以跟誰聯繫來解決潛在的問題？</a>
                                    </div>

                                    <div id="GenernalQuestionNineContent" class="collapse"
                                        aria-labelledby="GenernalQuestionNine" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>請發送電子郵件至<a href="mailto:support@trinka.ai">support@trinka.ai</a>。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="tab-pane" id="SecurityTab">
                            <div class="accordion" id="SecurityTabQuestion">
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">Trinka能存取我的密碼嗎？</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse show"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>不可以，Trinka無法存取敏感資訊，例如密碼或信用卡資訊。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">我的數據安全保密嗎？</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>我們非常重視隱私和資料安全，Trinka使用256位公開金鑰/私密金鑰加密進行資料和檔案傳輸，並持有高保證的SSL證書——全球公認的安全證書和防範威脅的最高措施，我們也不會與任何協力廠商共用您的私人資料。如果您有任何疑問或需要更多資訊，請發送電子郵件至 <a href="mailto:support@trinka.ai">support@trinka.ai</a>與我們聯繫。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="FAQFooterSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="FAQfooterText">
                    <h2>您還在等什麼？</h2>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW&_ga=2.236047556.496124804.1628486552-354402315.1626066855-354402315" target="_blank">免費註冊！</a>
                </div>
            </div>
        </div>
    </div>
</div>